// 9fbef606107a605d69c0edbcd8029e5d
import { initiateApiCall } from '../../handler';
import endpoints from '../../endpoints';

/**
 * Abstractor layer for loading Product List Tabs data
 */
const Abstractor = {
  getData: (
    {
      categoryId,
      rows = 18,
      fields = 'imageUrl,seo_token,product_name,prodpartno,product_type,TCPPrimaryBrandUSStore,TCPPrimaryBrandCanadaStore',
      brand = '',
      isTabbedModule = false,
      moduleGBundleVariation = false,
    },
    xappURLConfig
  ) => {
    const body = {
      start: 0,
      rows,
      variants: true,
      'variants.count': 0,
      version: 'V2',
      pagetype: 'boolean',
      'p-id': `categoryPathId:"${categoryId.replace(/\|/g, '>')}"`,
      filter: 'v_qty:[1 TO *] OR isVMPEnabled:true',
      fields,
    };

    if (brand) {
      body.brand = brand;
      body.fields += `,uniqueId,min_offer_price,min_list_price,product_type`;
    }
    if (isTabbedModule) {
      body.fields += `,uniqueId,min_offer_price,min_list_price,TCPBazaarVoiceRating,TCPBazaarVoiceReviewCount,TCPMerchantTagUSStore,TCPMerchantTagCanadaStore,TCPStyleTypeUS,TCPStyleTypeCA,TCPStyleQTYCA,TCPStyleQTYUS,TCPSwatchesUSStore,TCPSwatchesCanadaStore,swatchimage,related_product_swatch_images,TCPColor,auxdescription`;
    }
    if (moduleGBundleVariation) {
      body.fields += `,uniqueId,min_offer_price,min_list_price`;
    }
    const payload = {
      body,
      webService: endpoints.getProductviewbyCategory,
    };

    return initiateApiCall(payload, null, xappURLConfig)
      .then(Abstractor.processData)
      .catch(Abstractor.handleError);
  },
  processData: (res) => {
    return res.body.response.products.map((item) => {
      const {
        imageUrl: [imageUrl],
        seo_token: seoToken,
        uniqueId,
        product_type: productType,
      } = item;
      const pdpPathChar = productType === 'BUNDLE' ? 'b' : 'p';
      return {
        ...item,
        pdpUrl: `/${pdpPathChar}?${pdpPathChar}id=${seoToken || uniqueId}`,
        pdpAsPath: `/${pdpPathChar}/${seoToken || uniqueId}`,
        /*
           In Android, the images are not loading with www.childrensplace.com domain due to
           some security issue.
           TODO: This should be removed once we start getting CDN URL from the unbxd.
        */
        imageUrl: [
          imageUrl.replace('https://www.childrensplace.com', 'https://test4.childrensplace.com'),
        ],
      };
    });
  },
  // eslint-disable-next-line no-console
  handleError: (e) => console.log(e),
};
export default Abstractor;
